import { AccountGuidError } from '@signal/utils/errors'
import React, { PureComponent } from 'react'
import UI_BASE_PATH from '@signal/core/baseline/app/base-path'
import getLogger from '@signal/core/fe-logging'
import { getAcctSelectorUrl } from '@signal/core/router/redirect'
import NotFound from '../NotFound'
import isDevelopment from '@signal/utils/env/isDevelopment'

class ErrorBoundary extends PureComponent {
  state = { hasError: false }

  componentDidCatch(error, { componentStack }) {
    if (error instanceof AccountGuidError) {
      this.setState({ hasError: true })
      if (!isDevelopment) {
        setTimeout(() => {
          const { redirectUrl } = this.props
          window.location.replace(redirectUrl)
        }, 3000)
      }
      return
    }

    // log exception with stack before rethrow
    getLogger().exception(error, componentStack)

    throw error
  }

  render() {
    if (this.state.hasError) {
      return <NotFound />
    }

    return this.props.children
  }
}

function withRedirect(WrappedComponent, props) {
  const { redirectPath } = props
  const redirectUrl = `${getAcctSelectorUrl(`${UI_BASE_PATH}${redirectPath}`)}`
  return <WrappedComponent redirectUrl={redirectUrl} {...props} />
}

export const AccountGuidErrorBoundary = props =>
  withRedirect(ErrorBoundary, props)
